@if (unlockFeatureModalData) {
  <slotcom-navigation-button
    type="close"
    (click)="closeModal()">
  </slotcom-navigation-button>

  <div class="c-unlockFeatureModal">
    <div class="c-unlockFeatureModal__background">
      <div class="c-unlockFeatureModal__title">
        @if (unlockFeatureModalData.data.featureId === EnumUnlockedFeature.Challenges) {
          <span class="dc-title">{{ 'home.lobby.modals.unlock-feature.challenges.title' | translate }}</span>
        }
        @if (unlockFeatureModalData.data.featureId === EnumUnlockedFeature.Ranking) {
          <span>{{ 'home.lobby.modals.unlock-feature.ranking.title' | translate }}</span>
        }
        @if (unlockFeatureModalData.data.featureId === EnumUnlockedFeature.Highscore) {
          <span>{{ 'home.lobby.modals.unlock-feature.highscore.title' | translate }}</span>
        }
        @if (unlockFeatureModalData.data.featureId === EnumUnlockedFeature.LimitedTimeEvents) {
          <span>{{ 'home.lobby.modals.unlock-feature.multievents.title' | translate }}</span>
        }
      </div>
      <div class="c-unlockFeatureModal__feature">
        @if (unlockFeatureModalData.data.featureId === EnumUnlockedFeature.Challenges) {
          <div class="c-unlockFeatureModal__icon-front-shine shine-dc"></div>
        } @else {
          <div class="c-unlockFeatureModal__icon-front-shine"></div>
        }
        <div
          class="c-unlockFeatureModal__icon c-unlockFeatureModal__icon--{{
            unlockFeatureModalData.data.featureId
          }}"></div>
        <div
          class="c-unlockFeatureModal__padlock c-unlockFeatureModal__padlock--{{
            unlockFeatureModalData.data.featureId
          }}"></div>
      </div>
      <div class="c-unlockFeatureModal__dialog">
        @if (unlockFeatureModalData.data.featureId === EnumUnlockedFeature.Challenges) {
          <div class="c-unlockFeatureModal__juliet juliet-dc"></div>
        } @else {
          <div class="c-unlockFeatureModal__juliet"></div>
        }
        @if (unlockFeatureModalData.data.featureId === EnumUnlockedFeature.Challenges) {
          <slotcom-tooltip-bubble
            id="tooltip-bubble-1"
            [classes]="['c-tooltipBubble--onboarding']"
            borderRadius="25"
            arrowPosition="left"
            arrowPercentPosition="50">
            <span [innerHTML]="'home.lobby.modals.unlock-feature.challenges.message' | translate"></span>
          </slotcom-tooltip-bubble>
        }
        @if (unlockFeatureModalData.data.featureId === EnumUnlockedFeature.Ranking) {
          <slotcom-tooltip-bubble
            id="tooltip-bubble-2"
            [classes]="['c-tooltipBubble--onboarding']"
            borderRadius="75"
            arrowPosition="left"
            arrowPercentPosition="50">
            <span [innerHTML]="'home.lobby.modals.unlock-feature.ranking.message' | translate"></span>
          </slotcom-tooltip-bubble>
        }
        @if (unlockFeatureModalData.data.featureId === EnumUnlockedFeature.Highscore) {
          <slotcom-tooltip-bubble
            id="tooltip-bubble-3"
            [classes]="['c-tooltipBubble--onboarding']"
            borderRadius="75"
            arrowPosition="left"
            arrowPercentPosition="50">
            <span [innerHTML]="'home.lobby.modals.unlock-feature.highscore.message' | translate"></span>
          </slotcom-tooltip-bubble>
        }
        @if (unlockFeatureModalData.data.featureId === EnumUnlockedFeature.LimitedTimeEvents) {
          <slotcom-tooltip-bubble
            id="tooltip-bubble-3"
            [classes]="['c-tooltipBubble--onboarding']"
            borderRadius="75"
            arrowPosition="left"
            arrowPercentPosition="50">
            <span [innerHTML]="'home.lobby.modals.unlock-feature.multievents.message' | translate"></span>
          </slotcom-tooltip-bubble>
        }
      </div>
      <slotcom-button
        data-testid="slotcom_unlockFeatureModal_dialog"
        class="c-button--pink"
        (safeClick)="openFeature()"
        audioType="functionality">
        {{
          unlockFeatureModalData.data.featureId === EnumUnlockedFeature.Challenges
            ? ('home.buttons.accept-challenge' | translate | uppercase)
            : ''
        }}
        {{
          unlockFeatureModalData.data.featureId === EnumUnlockedFeature.Ranking
            ? ('home.buttons.lets-win' | translate | uppercase)
            : ''
        }}
        {{
          unlockFeatureModalData.data.featureId === EnumUnlockedFeature.Highscore
            ? ('home.buttons.get-over-it' | translate | uppercase)
            : ''
        }}
        {{
          unlockFeatureModalData.data.featureId === EnumUnlockedFeature.LimitedTimeEvents
            ? ('home.buttons.go' | translate | uppercase)
            : ''
        }}
      </slotcom-button>
    </div>
  </div>
}
